import { colors } from "../../utils/constants";
import "./InfoCard.scss";

const InfoCard = (props) => {
  // #fec800 -- yellow
  // #282c34 -- gray

  return (
    <div className="col-md-4">
      <div
        className="card"
      >
        <div className="card-body">
            <h5
              className="card-title"
            >
              {props.name}
            </h5>

            <div className="d-flex align-items-center my-3">
              <h3 className="count-txt">
                {props.currMonth}
              </h3>
              <p className="count-subtxt badge text-bg-secondary" >
                this month
              </p>
            </div>
            
              <p className="card-btm-txt">
                <span>{props.currYear}</span>  new {props.name.toLowerCase()} this year
              </p>
              
            

            {/* <div style={{ alignItems: "baseline" }} className="d-flex mb-3">
              <h2 className="fw-bolder me-1 text-primary">{props.currMonth}</h2>
              <p className="fw-thin fs-2 mb-0">this month</p>
            </div> */}
         
        </div>
        {/* <div className="card-footer w-100"></div> */}
      </div>
    </div>
  );
};

export default InfoCard;
